export function authHeader() {
    // return authorization header with jwt token
    var token;
    if(localStorage.getItem('tmp')){
        token = localStorage.getItem('tmp');
    }
    else{
        token = sessionStorage.getItem('tmp');
    }


    if (token) {
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/helpers/auth-header.js